import React from 'react';
import PropTypes from 'prop-types';
import { 
  Tabs, 
  Tab, 
  Box, 
  Grid, 
} from '@material-ui/core';

function TabsControl({
  tabs = [],
  value = 0,
  onChange,
  spacing = 2,
  renderFields,
}) {
  return (
    <Grid item xs={12} style={{ 
      marginBottom: 16, 
    }}>
      <Tabs
        value={value}
        onChange={(_, newValue) => onChange(newValue)}
        variant="fullWidth"
        indicatorColor="primary"
        textColor="primary"
      >
        {tabs.map((tab, idx) => (
          <Tab key={idx} label={tab.label} />
        ))}
      </Tabs>
      <Box mt={2}>
        <Grid container spacing={spacing}>
          {renderFields(tabs[value]?.fields || [], `tab${value}_`)}
        </Grid>
      </Box>
    </Grid>
  );
}

TabsControl.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      fields: PropTypes.array.isRequired,
    }),
  ).isRequired,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  spacing: PropTypes.number,
  renderFields: PropTypes.func.isRequired,
};

export default TabsControl;
